(function index(global) {
  'use strict';

  if (!global.NewHomeSource.Tracking.CommentsQuestionsFormTracking) {
    return;
  }

  const commentsQuestionsFormTracking = new global.NewHomeSource.Tracking.CommentsQuestionsFormTracking();
  commentsQuestionsFormTracking
    .setRootNode(document.querySelector('[data-comments-questions-form]'))
    .initialize();
}(window));
